import React, { useState } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import Statistic, { BreakdownItem, StatisticCaption, StatisticPill } from './Statistic';

export interface StatisticConfig {
  title: string;
  type: 'chart' | 'value';
  value?: string | number | null;
  formatter?: (value: string | number | null) => string;
  icon?: IconProp;
  iconColor?: string;
  /** One pill, or several shown side by side under the value. */
  pill?: StatisticPill | StatisticPill[];
  breakdown?: BreakdownItem[];
  dataCy?: string;
  /** Opt-in: the title becomes a dotted-underline term that explains itself. */
  caption?: StatisticCaption;
  /** Set false to remove the show/hide eye icon. Defaults to true. */
  allowHide?: boolean;
}

interface StatisticsProps {
  statistics: StatisticConfig[];
}

const Statistics: React.FC<StatisticsProps> = ({ statistics }) => {
  const [collapsed, setCollapsed] = useState<Record<number, boolean>>({});

  const handleToggleCollapse = (idx: number) => {
    setCollapsed((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  return (
    <div className="statistic-stack">
      {statistics.map((stat, idx) => (
        <Statistic
          key={stat.title}
          {...stat}
          collapsed={collapsed[idx] ?? false}
          onToggleCollapse={() => handleToggleCollapse(idx)}
        />
      ))}
    </div>
  );
};
export default Statistics;
